import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GoBell, GoPeople } from "react-icons/go";
import { IoIosArrowRoundForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { apiRequest } from "../api/apiRequest";
import bandeiraPt from "../assets/img/flags/64/Brazil.png";
import bandeiraEn from "../assets/img/flags/64/United-Kingdom.png";

function Navbar() {
    const { i18n, t } = useTranslation();
    const [showNotifications, setShowNotifications] = useState(false);
    const [currentLang, setCurrentLang] = useState(i18n.language || "pt");
    const [notificacoes, setNotificacoes] = useState([]);
    const [total, setTotal] = useState(0);
    const [error, setError] = useState(null);

    const formatDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString.replace(" ", "T"));
        const now = new Date();
        const diffMs = now - date;
        const diffSeconds = Math.floor(diffMs / 1000);
        const diffMinutes = Math.floor(diffSeconds / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffSeconds < 60) {
            return `há ${diffSeconds} segundo${diffSeconds > 1 ? "s" : ""}`;
        } else if (diffMinutes < 60) {
            return `há ${diffMinutes} minuto${diffMinutes > 1 ? "s" : ""}`;
        } else if (diffHours < 24) {
            return `há ${diffHours} hora${diffHours > 1 ? "s" : ""}`;
        } else if (diffDays < 30) {
            return `há ${diffDays} dia${diffDays > 1 ? "s" : ""}`;
        } else if (diffDays < 365) {
            const diffMonths = Math.floor(diffDays / 30);
            return `há ${diffMonths} mês${diffMonths > 1 ? "es" : ""}`;
        } else {
            const diffYears = Math.floor(diffDays / 365);
            return `há ${diffYears} ano${diffYears > 1 ? "s" : ""}`;
        }
    };

    useEffect(() => {
        let intervalId;

        const fetchData = async () => {
            try {
                const response = await apiRequest("GET", `/notificacoes`, '', {
                    lido: 0,
                });
                setNotificacoes(
                    (response.data?.data || []).sort(
                        (a, b) => new Date(b.criado) - new Date(a.criado)
                    )
                );
                setTotal(response.data?.total || 0);
                setError(null);
            } catch (error) {
                console.error("Erro ao buscar notificações:", error);
                setError(error);
            }
        };

        fetchData();

        // Atualiza a cada 5 minuto (300.000 ms)
        intervalId = setInterval(fetchData, 300000);

        return () => clearInterval(intervalId);
    }, []);


    const toggleNotifications = (e) => {
        e.preventDefault();
        setShowNotifications(!showNotifications);
    };

    const toggleLanguage = () => {
        const newLang = currentLang === "pt" ? "en" : "pt";
        i18n.changeLanguage(newLang);
        setCurrentLang(newLang);
    };

    return (
        <div className="row d-flex" style={{ width: "100%" }}>
            <nav
                className="navbar navbar-static-top bg-transparent d-flex flex-row-reverse"
                role="navigation"
                style={{ width: "100%", marginTop: "10px" }}
            >
                <div className="d-flex align-items-center flex justify-end pr-4">
                    {/* Troca de idioma */}
                    <div onClick={toggleLanguage} style={{ cursor: "pointer", marginRight: "15px" }}>
                        <img
                            src={currentLang === "pt" ? bandeiraEn : bandeiraPt}
                            alt="flag"
                            style={{ width: "28px" }}
                        />
                    </div>

                    {/* Notificações */}
                    <div className="nav navbar-top-links ml-2" style={{ marginRight: "15px" }}>
                        <div className="dropdown">
                            <a
                                className="dropdown-toggle count-info"
                                onClick={toggleNotifications}
                                href="#"
                            >
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <GoBell
                                        style={{ fontSize: "18px", padding: "0", color: "#232730" }}
                                    />
                                    {total > 0 && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "-5px",
                                                left: "-5px",
                                                width: "20px",
                                                height: "20px",
                                                backgroundColor: "#043A5E",
                                                borderRadius: "50%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#fff",
                                                fontSize: "10px",
                                                fontWeight: "bold",
                                                border: "2px solid white",
                                            }}
                                        >
                                            {total}
                                        </div>
                                    )}
                                </div>
                            </a>

                            {showNotifications && (
                                <ul
                                    className="dropdown-menu dropdown-alerts"
                                    style={{ display: "block", width: "320px", padding: "10px" }}
                                >
                                    {notificacoes.length > 0 ? (
                                        notificacoes.slice(0, 5).map((item) => {
                                            const destino = item.url_destino ? item.url_destino : "/#/notificacoes";

                                            return (
                                                <li
                                                    key={item.id}
                                                    style={{
                                                        listStyle: "none",
                                                        borderBottom: "1px solid #e7eaec",
                                                        padding: "10px 0",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => (window.location.href = destino)}
                                                >
                                                    <div className="d-flex justify-content-between">
                                                        <span
                                                            style={{
                                                                color: "#6C737F",
                                                                maxWidth: "75%",
                                                            }}
                                                        >
                                                            {item.descricao}
                                                        </span>
                                                        <span className="font-weight-light">
                                                            {formatDate(item.criado)}
                                                        </span>
                                                    </div>
                                                </li>
                                            );
                                        })
                                    ) : (
                                        <li
                                            style={{
                                                listStyle: "none",
                                                textAlign: "center",
                                                color: "#6C737F",
                                            }}
                                        >
                                            {t("sideMenu.noNotifications")}
                                        </li>
                                    )}

                                    <li
                                        style={{
                                            listStyle: "none",
                                            marginTop: "10px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <Link
                                            to={"/notificacoes"}
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                                color: "inherit",
                                                textDecoration: "none",
                                            }}
                                        >
                                            {t("sideMenu.seeMore")}
                                            <IoIosArrowRoundForward
                                                style={{
                                                    fontSize: "1.3rem",
                                                    marginLeft: "5px",
                                                }}
                                            />
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </div>

                    <a href="/#/profile">
                        <GoPeople
                            style={{ fontSize: "18px", marginLeft: "10px", cursor: "pointer" }}
                        />
                    </a>
                </div>
            </nav>
        </div>
    );
}

export default Navbar;